import { rolesAndPromissionAPI } from '@/providers/apis/roles-and-permission/roles-and-permission';
import { rosterAPI } from '@/providers/apis/roster/roster';

export default {
    namespaced: true,

    state: {
        countriesList: [],
        statesList: [],
        rolesList: [],
    },

    mutations: {
        getCountriesList(state: any, countries: any) {
            state.countriesList = countries;
        },
        getStateList(state: any, statesList: any) {
            state.statesList = statesList;
        },
        getRolesList(state: any, rolesList: any) {
            state.rolesList = rolesList;
        },
    },

    actions: {
        fetchCountriesList({ commit }: any) {
            rosterAPI.fetchCountriesList().then((countriesList: any) => {
                commit('getCountriesList', countriesList);
            });
        },

        fetchStatesList({ commit }: any, params: any) {
            rosterAPI.fetchStates(params).then((stateList: any) => {
                commit('getStateList', stateList);
            });
        },

        fetchRolesList({ commit }: any, params: any) {
            rolesAndPromissionAPI.fetchRoleList().then((rolesList: any) => {
                commit('getRolesList', rolesList);
            });
        },
    },
};
